import { v4 as uuidv4 } from "uuid";

import { createApiMutationHook, IApiMutationFunction } from "../../utils";
import { ILocationResource } from "../types";

export type ILocationCreateMutationParameters = {
    uuid?: string;
    title: string;
    isDefault?: boolean;
};

export type ILocationCreateMutationResult = ILocationResource;

export const locationCreateMutation: IApiMutationFunction<ILocationCreateMutationParameters> = ({
    uuid: providedUuid,
    title,
    isDefault,
}) => {
    return {
        method: "POST",
        url: "/locations",
        data: {
            uuid: providedUuid ?? uuidv4(),
            title,
            isDefault,
        },
    };
};

export const useLocationCreateMutation = createApiMutationHook<
    ILocationCreateMutationParameters,
    ILocationCreateMutationResult
>(locationCreateMutation);
